<template>
  <div class="outer">
    <div class="index">
      <div class="upload">
        <el-upload
          class="upload-element"
          :auto-upload="true"
          :show-file-list="false"
          :on-change="uploadChange"
          :http-request="uploadFile"
          action
          drag
          multiple
        >
          <div class="choic-outer">
            <div class="choice-inner">
              <p class="choice-file">
                <span class="choice-title">选择文件</span>
              </p>
            </div>
            <span class="or">或</span>
            <div class="drag">
              <p class="drag-inner">
                <span>在此拖拽文件</span>
              </p>
            </div>
          </div>
          <div class="hint">
            <span>允许上传格式: 所有图像和PDF</span>
          </div>
        </el-upload>
      </div>
    </div>
    <div class="task-info">
      <ul class="info-header">
        <li class="date">
          <span>日期</span>
        </li>
        <li class="file-name">
          <span>文件名</span>
        </li>
        <li class="file-size">
          <span>文件大小</span>
        </li>
        <li class="transfer-format">
          <span>转换格式</span>
        </li>
        <li class="status">
          <span>状态</span>
        </li>
        <li class="operation">
          <span>操作</span>
        </li>
      </ul>
    </div>
    <div class="task-info-content" v-for="item in recordList" :key="item.id">
      <ul class="row-info">
        <li class="date">
          <span>{{ item.datetime ? item.datetime : '0000年00月00日' }}</span>
        </li>
        <li class="file-name">
          <span>{{ item.filename }}</span>
        </li>
        <li class="file-size">
          <span>{{ item.size }}M</span>
        </li>
        <li class="transfer-format" :class="item.status===0 ? '':'hidden-select'">
          <el-select
            :class="item.convert_type ? 'noHaveBorder':''"
            v-model="item.convert_type"
            placeholder="选择转换格式"
            :disabled="item.status===0? false: true"
          >
            <el-option v-for="row in item.source" :key="row.id" :value="row.convert_type"></el-option>
          </el-select>
        </li>
        <li class="status">
          <span v-if="item.status===0">未开始</span>
          <span class="status" :class="'black'" v-else-if="item.status===1">进行中</span>
          <span class="status" :class="'green'" v-else>完成</span>
        </li>
        <li class="operation">
          <div
            class="transfer-outer-layout"
            @mouseenter="changeTransferSvg(item.id)"
            @mouseleave="recoverTransferSvg"
            :class="item.status===0&&item.convert_type?'':'hidden'"
          >
            <div class="transfer" @click="transferRecord(transferSvgName,item.id,item.status)">
              <svg-icon
                v-if="(changeTransferHoverSvgName===item.id)&&(item.status===0)&&item.convert_type"
                :name="'ssss'"
              ></svg-icon>
              <svg-icon
                v-else
                :name="changeTransferHoverSvgName===item.id ? 's':changeTransferSvgName(item.status,item.convert_type)"
              ></svg-icon>
            </div>
          </div>
          <div
            class="download-outer-layout"
            @mouseenter="changeDownloadSvg(item.id)"
            @mouseleave="recoverDownloadSvg"
            :class="item.status===2 ? '':'forbidden'"
          >
            <div class="download" @click="downloadRecord(item.id,item.status)">
              <svg-icon v-if="changeDownloadHoverSvgName===item.id&&item.status===2" :name="'画板'"></svg-icon>
              <svg-icon v-else :name="item.status===2 ? 'sswess':'ss(1)'"></svg-icon>
            </div>
          </div>
          <div
            class="delete-outer-layout"
            :class="item.status===1?'forbidden':''"
            @mouseenter="chanageDeleteSvg(item.id)"
            @mouseleave="recoverDeleteSvg()"
          >
            <div class="delete" @click="deleteTransferRecord(item.id,item.status)">
              <svg-icon v-if="item.status===1" :name="'画板(2)'"></svg-icon>
              <svg-icon v-else :name="changeDeleteHoverSvgName===item.id? '画板(1)':deleteSvgName"></svg-icon>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <deletewarning
      @inform="inform"
      :isShowDeleteWarning="isShowDeleteWarning"
      :deleteRecordId="deleteRecordId"
    ></deletewarning>
  </div>
</template>

<script>
import deletewarning from '../components/DeleteWarning'
import { baseUrl } from '../../config/env'
export default {
  data() {
    return {
      //sswess 蓝色下载
      // 矩形 灰色下载
      // 画板 白色下载
      downloadSvgName: 'ss(1)',
      // 画板(1) 白色删除
      // 画板(2) 灰色删除后
      deleteSvgName: 'ss',
      //编组 23 蓝色转换
      transferSvgName: 's',
      isShowDeleteWarning: false,
      recordList: [],
      changeTransferHoverSvgName: '',
      changeDeleteHoverSvgName: '',
      changeDownloadHoverSvgName: '',
      deleteRecordId: ''
    }
  },
  watch: {},
  components: {
    deletewarning
  },
  async created() {
    let response = await this.$http.get('/file_info')
    if (response.res) {
      response.res.forEach(element => {
        element['source'] = [
          {
            convert_type: 'xlsx'
          },
          {
            convert_type: 'docx'
          },
          {
            convert_type: 'txt'
          },
          {
            convert_type: 'pptx'
          },
          {
            convert_type: 'pdf'
          }
        ]
      })
    }
    this.recordList = response.res
    this.sockets.subscribe('uid', data => {
      this.sockets.subscribe(data.uid, result => {
        if (result.res) {
          result.res.forEach((element, index) => {
            this.recordList[index].status = element.status
          })
        }
      })
    })
    // this.sockets.subscribe('server_response', data => {
    //   if (data.res) {
    //     data.res.forEach((element, index) => {
    //       this.recordList[index].status = element.status
    //     })
    //   }
    // })
  },
  methods: {
    changeTransferSvgName(status, isHaveConvertType) {
      switch (status) {
        case 0:
          if (isHaveConvertType) {
            return '编组 23'
          } else {
            return 's'
          }
        case 1:
          return 's'
        case 2:
          return 's'
        default:
          return 's'
      }
    },
    handleChange(value, recordId) {
      this.recordList.forEach(element => {
        if (recordId === element.id) {
          element.convert_type = value
        }
      })
    },
    async getConvertType(recordID) {
      // TODO: else logic
      let result = ''
      this.recordList.forEach(element => {
        if (element.id === recordID) {
          result = element.convert_type
        }
      })
      return result
    },
    async transferRecord(param, recordID, recordStatus) {
      if (recordStatus === 1) {
        console.warn('正在转换中')
        return
      } else if (recordStatus === 2) {
        console.warn('转换已完成')
        return
      }
      let convertType = await this.getConvertType(recordID)
      if (convertType) {
        let data = { type: convertType }
        let response = await this.$http.post(`/convert/${recordID}`, data)
        response.res.forEach((element, index) => {
          this.recordList[index].status = element.status
        })
      } else {
        console.warn('请选择正确的转换格式')
        return
      }
    },
    downloadRecord(recordId, recordStatus) {
      if (recordStatus === 2) {
        window.open(`${baseUrl}/download/convert/${recordId}`)
      } else if (recordStatus === 1) {
        console.warn('转换任务正在进行')
        return
      } else {
        console.warn('还未进行转换')
        return
      }
    },
    async formatUploadTime() {},
    async getUploadTime() {},
    async uploadChange(fileObj) {
      console.debug('res', fileObj)
    },
    async uploadFile(param) {
      let fileObject = param.file
      let formData = new FormData()
      formData.append('file', fileObject)
      let response = await this.$http.post('/upload', formData)
      if (response.err === '0') {
        response.res.files.forEach(element => {
          element['source'] = [
            {
              convert_type: 'xlsx'
            },
            {
              convert_type: 'docx'
            },
            {
              convert_type: 'txt'
            },
            {
              convert_type: 'pptx'
            },
            {
              convert_type: 'pdf'
            }
          ]
        })
        this.recordList = response.res.files
      } else if (response.err === '400') {
        this.$message({ type: 'error', message: '上传文件类型错误' })
      }
    },
    deleteTransferRecord(recordId, recordStatus) {
      this.deleteRecordId = recordId
      switch (recordStatus) {
        case 0:
          this.isShowDeleteWarning = true
          break
        case 1:
          this.isShowDeleteWarning = false
          break
        case 2:
          this.isShowDeleteWarning = true
          break
        default:
          this.isShowDeleteWarning = false
          break
      }
    },
    async inform(param, deleteRecordId) {
      this.isShowDeleteWarning = false
      /**
       * if param false do not delete param true delete
       */
      if (param) {
        let response = await this.$http.delete(`/delete_file/${deleteRecordId}`)
        console.log(response)
        let getRecordResponse = await this.$http.get('/file_info')
        if (getRecordResponse.res) {
          getRecordResponse.res.forEach(element => {
            element['source'] = [
              {
                convert_type: 'xlsx'
              },
              {
                convert_type: 'docx'
              },
              {
                convert_type: 'txt'
              },
              {
                convert_type: 'pptx'
              },
              {
                convert_type: 'pdf'
              }
            ]
          })
        }
        this.recordList = getRecordResponse.res
      }
    },
    /**
     * dom operation
     */
    chanageDeleteSvg(recordId) {
      this.changeDeleteHoverSvgName = recordId
    },
    recoverDeleteSvg() {
      this.changeDeleteHoverSvgName = 0
    },
    changeDownloadSvg(recordId) {
      this.changeDownloadHoverSvgName = recordId
    },
    recoverDownloadSvg() {
      this.changeDownloadHoverSvgName = 0
    },
    changeTransferSvg(recordId) {
      this.changeTransferHoverSvgName = recordId
    },
    recoverTransferSvg() {
      this.changeTransferHoverSvgName = 0
    }
  },
  mounted() {}
}
</script>

<style>
.outer {
  height: 100%;
}
.index {
  height: 100%;
  padding-left: 70px;
  padding-right: 70px;
}
.index .upload {
  width: 100%;
  height: 144px;
  margin-top: 30px;
}
.index .upload .upload-element {
  width: 100%;
}
.index .upload .upload-element .choic-outer {
  width: 100%;
  display: flex;
}
.index .upload .el-upload.el-upload--text {
  width: 100%;
}
.index .upload .upload-element .el-upload-dragger {
  width: 100%;
  height: 144px;
  border-radius: 5px;
  background-color: rgba(71, 90, 114, 0.1);
}
.index .upload .choice-inner {
  flex: 1;
}
.el-upload-dragger {
  background-color: #fff;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 360px;
  height: 180px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.index .upload .upload-element .el-upload-dragger .choice-file {
  float: right;
  width: 158px;
  height: 50px;
  background: rgba(75, 129, 198, 1);
  box-shadow: 0px 2px 14px 0px rgba(218, 218, 218, 0.5);
  border-radius: 25px;
  margin-top: 30px;
}
.index .upload .upload-element .el-upload-dragger .choice-file .choice-title {
  width: 72px;
  height: 25px;
  line-height: 50px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
}
.index .upload .drag {
  flex: 1;
}
.index .upload .drag .drag-inner {
  float: left;
  width: 84px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(71, 90, 114, 1);
  margin-top: 45px;
  margin-left: 10px;
}
.index .upload .upload-element .or {
  display: inline-block;
  width: 14px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(188, 188, 188, 1);
  margin-top: 45px;
  margin-left: 10px;
}
.index .upload .upload-element .hint {
  display: inline-block;
  width: 190px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(188, 188, 188, 1);
  margin-top: 24px;
}
.outer {
  padding-left: 40px;
  padding-right: 40px;
}
.outer .task-info {
  margin-top: 25px;
  height: 53px;
  background-color: rgba(71, 90, 114, 0.1);
}
.outer .task-info .info-header {
  list-style: none;
  display: flex;
}
.outer .task-info .info-header .date {
  flex: 1.2;
}
.outer .task-info .info-header .date span {
  display: inline-block;
  width: 28px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
  margin-left: 20px;
}
.outer .task-info .info-header .file-name {
  flex: 2;
}
.outer .task-info .info-header .file-name span {
  display: inline-block;
  width: 50px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
}
.outer .task-info .info-header .file-size {
  flex: 0.8;
  text-align: center;
}
.outer .task-info .info-header .file-size span {
  display: inline-block;
  width: 60px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
}
.outer .task-info .info-header .transfer-format {
  flex: 2;
}
.outer .task-info .info-header .transfer-format span {
  display: inline-block;
  width: 60px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
  margin-left: 20px;
}
.outer .task-info .info-header .status {
  flex: 1.5;
  text-align: center;
}
.outer .task-info .info-header .status span {
  display: inline-block;
  width: 28px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
}
.outer .task-info .info-header .operation {
  flex: 1.5;
  text-align: center;
}
.outer .task-info .info-header .operation span {
  display: inline-block;
  width: 28px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 15px;
}
.outer .task-info-content .row-info {
  display: flex;
  list-style: none;
  height: 60px;
  border: 1px solid rgba(236, 238, 240, 1);
}
.outer .task-info-content .row-info .date {
  flex: 1.2;
}
.outer .task-info-content .row-info .date span {
  display: inline-block;
  width: 107px;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 20px;
  margin-left: 20px;
}
.outer .task-info-content .row-info .file-name {
  flex: 2;
}
.outer .task-info-content .row-info .file-name span {
  display: inline-block;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 20px;
}
.outer .task-info-content .row-info .file-size {
  flex: 0.8;
  text-align: center;
}
.outer .task-info-content .row-info .file-size span {
  display: inline-block;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  margin-top: 20px;
}
.outer .task-info-content .row-info .transfer-format {
  flex: 2;
}
.outer .task-info-content .row-info .transfer-format .el-select {
  width: 100%;
  margin-top: 10px;
}
.outer
  .task-info-content
  .row-info
  .transfer-format.hidden-select
  .el-select
  .el-select__caret.el-input__icon.el-icon-arrow-up {
  display: none;
}
.outer
  .task-info-content
  .row-info
  .transfer-format
  .el-select
  .el-input__inner {
  background-color: rgba(71, 90, 114, 0.1);
  border: 1px solid rgba(75, 129, 198, 1) !important;
}
.outer
  .task-info-content
  .row-info
  .transfer-format
  .el-select.noHaveBorder
  .el-input__inner {
  background-color: rgba(71, 90, 114, 0.1);
  border: 1px solid rgba(71, 90, 114, 0.1) !important;
}
.el-select__caret.el-input__icon.el-icon-arrow-up {
  color: #4b81c6;
  font-weight: 600;
}
.outer
  .task-info-content
  .row-info
  .transfer-format
  .el-select.noHaveBorder
  .el-select__caret.el-input__icon.el-icon-arrow-up {
  color: #333;
  font-weight: 600;
}
/* .outer
  .task-info-content
  .row-info
  .transfer-format
  .el-select
  .el-input__inner {
  border: 1px solid #fff;
} */
/*
取消倒三角,下拉的距离
*/
.popper__arrow {
  display: none !important;
}

.el-select-dropdown.el-poppe {
}
.outer .task-info-content .row-info .status {
  flex: 1.5;
  text-align: center;
}
.outer .task-info-content .row-info .status span {
  display: inline-block;
  height: 20px;
  font-size: 14px;
  /* font-weight: 600;
  color: rgba(48, 48, 48, 1); */
  font-weight: 400;
  color: rgba(184, 184, 184, 1);
  margin-top: 20px;
}
.outer .task-info-content .row-info .status.black {
  color: #303030;
}
.outer .task-info-content .row-info .status.green {
  color: #4cd964;
}
.outer .task-info-content .row-info .operation {
  flex: 1.5;
  display: flex;
}
.outer .task-info-content .row-info .operation .transfer {
  flex: 1;
  height: 30px;
  border-left: 1px solid rgba(219, 219, 219, 1);
  margin-top: 15px;
  cursor: pointer;
  position: relative;
}
.outer .task-info-content .row-info .operation .transfer .svg-icon {
  height: 50px;
  width: 50px;
  position: absolute;
  top: -8px;
  left: 50%;
  margin-left: -25px;
}
.outer .task-info-content .row-info .operation .download {
  flex: 1;
  height: 30px;
  border-left: 1px solid rgba(219, 219, 219, 1);
  margin-top: 15px;
  cursor: pointer;
  position: relative;
}
.outer .task-info-content .row-info .operation .download .svg-icon {
  height: 50px;
  width: 50px;
  position: absolute;
  top: -8px;
  left: 50%;
  margin-left: -25px;
}
.outer .task-info-content .row-info .operation .delete-outer-layout {
  flex: 1;
}
.el-upload-dragger.isdrag-over:hover {
  /* border: 1px solid red; */
  border-color: red;
}
.outer .task-info-content .row-info .operation .delete-outer-layout:hover {
  flex: 1;
  background-color: #ff554b;
}
.outer
  .task-info-content
  .row-info
  .operation
  .delete-outer-layout:hover.forbidden {
  flex: 1;
  background-color: #fff;
  cursor: unset;
}
.outer .task-info-content .row-info .operation .delete:hover {
  border-left: 1px solid #ff554b;
}
.outer
  .task-info-content
  .row-info
  .operation
  .delete-outer-layout.forbidden
  .delete:hover {
  border-left: 1px solid #ccc;
  cursor: unset;
}

.outer .task-info-content .row-info .operation .download-outer-layout {
  flex: 1;
}
.outer .task-info-content .row-info .operation .download-outer-layout:hover {
  flex: 1;
  background-color: #4b81c6;
}
.outer
  .task-info-content
  .row-info
  .operation
  .download-outer-layout:hover.forbidden {
  flex: 1;
  background-color: #fff;
  cursor: text;
  cursor: unset;
}
.outer .task-info-content .row-info .operation .download:hover {
  border-left: 1px solid #4b81c6;
}
.outer
  .task-info-content
  .row-info
  .operation
  .download-outer-layout.forbidden
  .download:hover {
  border-left: 1px solid #ccc;
  cursor: unset;
}
.outer .task-info-content .row-info .operation .transfer-outer-layout {
  flex: 1;
}
.outer .task-info-content .row-info .operation .transfer-outer-layout:hover {
  flex: 1;
  background-color: #4b81c6;
}
.outer
  .task-info-content
  .row-info
  .operation
  .transfer-outer-layout:hover.hidden {
  flex: 1;
  background-color: #fff;
  cursor: unset;
}
.outer .task-info-content .row-info .operation .transfer:hover {
  border-left: 1px solid #4b81c6;
}
.outer
  .task-info-content
  .row-info
  .operation
  .transfer-outer-layout.hidden
  .transfer:hover {
  border-left: 1px solid #ccc;
  cursor: unset;
}

.outer .task-info-content .row-info .operation .delete {
  flex: 1;
  height: 30px;
  border-left: 1px solid rgba(219, 219, 219, 1);
  margin-top: 15px;
  cursor: pointer;
  position: relative;
}
.outer .task-info-content .row-info .operation .delete .svg-icon {
  height: 50px;
  width: 50px;
  position: absolute;
  top: -8px;
  left: 50%;
  margin-left: -25px;
}
.el-input__inner::-webkit-input-placeholder {
  color: #4b81c6;
}
.el-input__inner::-moz-placeholder {
  color: #4b81c6;
}
.el-input__inner:-ms-input-placeholder {
  color: #4b81c6;
}
.svg-icon.svg-icon--ss {
  color: white;
}
</style>